function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { internalUseOnlyPriority1 } from "./H1";
const Title1Styled = styled.div.withConfig({
  componentId: "sc-u27cpt-0"
})(["", ";"], internalUseOnlyPriority1);
/**
 * Titles are styled to be parents of text. A title style may or may not correspond directly with an HTML heading (H1, H2, etc).
 */

const Title1 = _ref => {
  let {
    small,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Title1Styled, _extends({
    small: small
  }, props), children);
};

export default Title1;
Title1.propTypes = {
  /** Content inside title */
  children: PropTypes.node.isRequired,

  /** Whether smaller styles should be applied */
  small: PropTypes.bool
};